import {createContext} from 'react';

const SocketContext = createContext({connection : {}});
export default SocketContext;